<template>
  <q-page padding class="row justify-center full-height full-width text-center">
    <div class="column flex-center text-center">
      <h4 class="q-my-md">Shop Login</h4>
        <div style="width: 300px">
          <q-input v-model="loginData.email" type="email" label="Email"
                   class="q-pa-sm" outlined
                   :error="loginError"
                   ref="emailInput"/>
          <q-input v-model="loginData.password" type="password" label="Password"
                   class="q-pa-sm" outlined
                   bottom-slots
                   :error-message="loginErrorMessage"
                   :error="loginError"
                   @keyup.enter="login"/>
          <q-btn color="primary" @click="login" class="full-width q-mx-md q-mt-lg q-mb-sm">Login</q-btn>
          <q-btn text-color="primary" to="/register-retail" class="full-width q-mx-md">Register</q-btn>
          <p class="q-pt-md">
            <small><router-link to="/login" class="text-primary">Looking For Industry?</router-link></small>
          </p>
        </div>
      </div>
  </q-page>
</template>

<script>

export default {
  name: 'PageLoginRetail',
  data () {
    return {
      loginData: {
        email: '',
        password: ''
      },
      loginError: false,
      loginErrorMessage: ''
    }
  },
  methods: {
    reset () {
      this.loginData.email = ''
      this.loginData.password = ''
      this.loginError = false
    },
    async login () {
      if (this.loginData.email && this.loginData.password) {
        try {
          await this.$store.dispatch('auth/login', this.loginData)
          await this.$store.dispatch('cart/init')
          await this.$store.dispatch('filters/fetchProductColours')
          this.reset()
          // eslint-disable-next-line no-undef
          analytics.track('Login')
          this.$router.push('stock')
        } catch (err) {
          if (err.networkError) {
            this.loginErrorMessage = 'Could not contact server'
          } else if (err.graphQLErrors && err.graphQLErrors.length) {
            this.loginErrorMessage = err.graphQLErrors[0].message
          } else {
            this.loginErrorMessage = 'Error'
          }
          this.loginError = true
        }
      } else {
        this.loginError = true
        this.loginErrorMessage = 'Incorrect username or password'
      }
    }
  },
  created () {
    this.$nextTick(() => {
      this.$refs.emailInput.focus()
      this.reset()
    })
  }
}
</script>
